const apiUrls = {
  local: 'http://localhost:8000/api',
  staging: 'https://dev-lcs-be.lemocrane.co.id/api',
  production: 'https://lcs-be.lemocrane.co.id/api',
};

const environment = (process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'local')
  .replace(/^['"]|['"]$/g, '')
  .toLowerCase();

export const apiUrl = apiUrls[environment] || process.env.REACT_APP_API_URL || apiUrls.local;
